import { useContext } from "react";
import { BackButtonEntityContext } from "../context";
import { useActiveEntity } from "./use-active-entity";
import { PAGE_HOME } from "../constants";
export var useBackButtonEntity = function () {
  var contextValue = useContext(BackButtonEntityContext);
  // console.log("CONTEXT VALUE", contextValue);
  var activeEntity = useActiveEntity();
  return contextValue || PAGE_HOME;
};